<template>
  <div class="wrapper">
        <div class="con-top-bg">
			<div class="title">
				<div class="label">拍品名称：</div>
				<div class="value c1">{{auctionInfo.name || ''}}</div>
			</div>
			<div class="title">
				<div class="label">需缴纳保证金：</div>
				<div class="value c2">￥{{auctionInfo.bond_money||'0.00'}}</div>
			</div>
		</div>

        <div class="con-wrap">
            <div class="tips-top">
                <div class="c2">大家都如何快速交钱？</div>
                <!-- <div class="c1"> 点击查看</div> -->
            </div>

            <div class="con-list list2">
                <div class="h2">
                   1.竞买人身份确认 <span class="c1">标的物交割时将核实该信息，请保证其真实有效，如非本人购买，请提前与资产处置单位确认是否可行。</span>
                </div>
                <div class="list-item"><span class="label">竞买人：</span> <span class="value">{{userInfo.nickname || ''}}</span>  （竞价成功后，将以此身份办理过户，如有委托，请咨询资产处理单位）</div>

                <div class="list-item full"><span class="label">真实姓名：</span> 
                    <el-input class="input" v-model="form.consignee"></el-input>
                </div>

                <div class="list-item full"><span class="label">联系电话：</span> 
                    <el-input class="input" v-model="form.mobile"></el-input>
                </div>


                <div class="list-item"><span class="label">证件类型：</span> 
                   <el-select placeholder="请选择证件类型" v-model="form.id_type">
                        <el-option label="身份证" value="1"></el-option>
                    </el-select>
                </div>

                <div class="list-item full"><span class="label">证件号码：</span> 
                    <el-input class="input" v-model="form.id_num"></el-input>
                </div>

                 
               

                 <div class="list-item full"><span class="label">所在地区：</span> 
                    <el-cascader  class="input" size="medium" :options="options" separator=" " v-model="selectedOptions"></el-cascader>
                </div>

                <div class="list-item full"><span class="label">所在街道：</span> 
                    <el-input class="input" v-model="form.address"></el-input>
                </div>
                <!-- <div class="list-item b-tip">注意：如果您是优先公人或存在委托关系时，
                    请联系处置单位并提供与报名一致的证件信息进行设置，设置后才有 <span>优</span>字 或 <span>委</span> 字标识 </div> -->

            </div>
            <div class="con-list">
                <div class="h2">
                    2.竞买人请确认以下事项并勾选 <span class="c1">因不符合条件参加竞买的，将取消您的竞得资格，竞买保证金不予退还并承担相应法律责任。</span>
                </div>
                <div class="list-item">·已阅读并知晓：拍下不买的后果，即保证金不予退还并承担相应的后果包括处罚等</div>
                <div class="list-item">·已阅读并知晓：本次报名仅代表本人，未接受他人委托参与竞买。（如需办理委托，请在报名前联系处理单位将双方信息录入系统）</div>
                <div class="list-item">· 已阅读并知晓：如您报名成功，您的姓名、证件号码、手机号、联系地址等信息将披露给资产处置单位及相关服务提供方，用于核实竞买人的真实身份、竞买资格及相关服务提供</div>
                <div class="list-item">· 已阅读并知晓：竞买人如果没有进行实地看样，视为接受标的所有瑕疵等细则</div>
                <div class="list-item">· 已阅读并同意 <span> 《竞拍服务协议》</span> </div>
                <div class="list-check"> <el-checkbox v-model="checkStatus" /> 本人已同意以上所有事项</div>
            </div>


            


        </div>

            <div class="pay-bot">需支付 <span class="bot-price">{{auctionInfo.bond_money||'0.00'}}</span> 
                <el-button class="btn" @click="payAction">去支付</el-button>
             </div>


  </div>
</template>

<script>
export default {
    data() {
        return {
            selectedOptions: [],
            auctionInfo: {},
            userInfo:{},//用户详情
            id: '',
            form: {
                id: '',
                consignee: '',
                mobile: '',
                id_type: '',
                id_num: '',
                address: '',
                area_id: ""
            },
            checkStatus: false
        }
    },
    created() {
        let addressList = this.$storage.get('areaList')
        if (addressList.hasOwnProperty('data')) {
            this.options = addressList.data || [];
        } else {
            this.options = addressList || [];
        }
        this.form.id = this.id = this.$route.query.id

        this.getAuctionInfo();
        this.getUserInfo()
    },
    methods: {
        payAction() {
            const _this = this
            if(!this.checkStatus) {
                this.$message({
                    message: "请先同意竞拍服务协议",
                    type: 'error'
                })
                return
            }

            if(!this.form.id_type) {
                this.$message({
                    message: "请选择证件类型",
                    type: 'error'
                })
                return
            }

            if(this.selectedOptions.length == 0) {
                 this.$message({
                    message: "请选择地址",
                    type: 'error'
                })
                return
            } else {
                this.$set(this.form, 'area_id', this.selectedOptions[this.selectedOptions.length - 1])
            }

            this.$api.auctionEnroll(this.form).then(res => {
                if(res.status){
                    this.$router.replace({
                        name: 'cashier',
                        params: {
                            order_id: res.data.id,
                            type: 10,
                            money: _this.auctionInfo.bond_money,
                            goodsId: this.id
                        }
                    })
                }else{
                    this.$message({
                        message: res.msg || '',
                        type: 'error'
                    })
                    // this.$common.errorToShow(res.msg);
                }
            },res => {
                this.submitStatus = false;
            });
        },
        getUserInfo() {
            this.$api.userInfo({}).then(res => {
                if (res.status) {
                    this.userInfo = res.data
                }
            });
        },
        getAuctionInfo() {
            let data = {
                id: this.id
            };
            let userToken = this.$storage.get("userToken")
            
            if (userToken) {
                data['token'] = userToken;
            }
            this.$api.auctionInfo(data).then(res => {
                if (res.status) {
                    this.auctionInfo = res.data;
                } else {
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .c1 {
        color: #FFC300;
    }
    .c2 {
        color: #FF4949;
    }
    .wrapper{
        width: 1176px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        margin: 20px auto;
    }
    .con-wrap {
        padding: 40px;
    }
    .pay-bot{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 50px 0;
        color: #222222;
        .bot-price {
            width: 107px;
            font-size: 32px;
            font-weight: bold;
            color: #FF4949;
        }
        .btn {
            width: 140px;
            height: 50px;
            background: #FFC300;
            border-radius: 10px;
            font-size: 24px;
            color: #222222;
        }
    }
    .con-list {
        .h2 {
            font-size: 18px;
            line-height: 31px;
            color: #222222;
            margin-bottom: 44px;
            span {
                font-size: 14px;
                line-height: 24px;
                color: #FFC300;
            }
        }
        .list-item {
            font-size: 14px;
            line-height: 24px;
            color: #707070;
            margin-bottom: 26px;
            padding-left: 20px;
            &.full {
                .input {
                    margin-left: 0;
                    width: 460px;
                }
            }
            .value {
                color: #222222;
            }
            .label {
                display: inline-block;
                min-width: 100px;
                position: relative;
                &::after {
                    content: '*';
                    position: absolute;
                    top: 0px;
                    left: -8px;
                    color: #FF4949;
                }
            }
            .input {
                width: 220px;
                margin:0  20px;
            }
        }
        .list-check {
            padding-left: 20px;
            color: #FF4949;
        }

        &.list2 {
            margin-top: 70px;
        }

        .b-tip {
            padding-left: 120px;
            color: #222222;
            span {
                display: inline-block;
                width: 14px;
                height: 14px;
                background: #FF4949;
                text-align: center;
                line-height: 14px;
                color: #FFFFFF;
                font-size: 12px;
            }
        }
        
    }
    .tips-top {
        width: 330px;
        height: 60px;
        background: rgba($color: #FF4949, $alpha: .1);
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 24px;
        font-size: 14px;
        padding-left: 70px;
        box-sizing: border-box;
        margin-bottom: 70px;
    }
    .con-top-bg {
		width: 100%;
		height: 130px;
		font-size: 28rpx;
		color: #222222;
        background: #F6F6F6;
        padding: 40px;
        box-sizing: border-box;
		.title{
			display: flex;
			margin-bottom: 14px;
		}
	}
</style>